import { render, staticRenderFns } from "./MyScoreCard.vue?vue&type=template&id=c1c8ea08&scoped=true&"
import script from "./MyScoreCard.vue?vue&type=script&lang=js&"
export * from "./MyScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./MyScoreCard.vue?vue&type=style&index=0&id=c1c8ea08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8ea08",
  null
  
)

export default component.exports